import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { 
  FaCloudUploadAlt, 
  FaHeadphones, 
  FaLanguage, 
  FaBookOpen, 
  FaPenNib 
} from 'react-icons/fa';

const UploadData = () => {
  const navigate = useNavigate();
  const tiles = [
    {
      key: 'listening',
      title: 'Upload Listening Question',
      description: 'Audio & Listening exercises',
      icon: <FaHeadphones size={50} className="text-primary mb-3 mx-auto" />
    },
    {
      key: 'grammar_vocab',
      title: 'Grammar & Vocab Question',
      description: 'Structure & Vocabulary tests',
      icon: <FaLanguage size={50} className="text-success mb-3 mx-auto" />
    },
    {
      key: 'reading',
      title: 'Reading Question',
      description: 'Reading comprehension passages',
      icon: <FaBookOpen size={50} className="text-warning mb-3 mx-auto" />
    },
    {
      key: 'kanji',
      title: 'Kanji Question',
      description: 'Kanji characters & meanings',
      icon: <FaPenNib size={50} className="text-danger mb-3 mx-auto" />
    }
  ];

  const handleTileClick = (key) => {
    if (key === 'listening') {
      navigate('/upload-jlpt-listening');
    } else {
      console.log(`Clicked on ${key}`);
      // Add other navigation logic here
    }
  };

  return (
    <Container fluid className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">
          <FaCloudUploadAlt className="me-2 text-primary" />
          Upload Data
        </h2>
        
        <div>
          <Button 
            variant="outline-primary" 
            size="lg"
            className="shadow-sm me-3"
            onClick={() => navigate('/add-question-type')}
          >
            Manage Question Type
          </Button>
          <Button 
            variant="outline-primary" 
            size="lg"
            className="shadow-sm me-3"
            onClick={() => navigate('/question-type-mapping')}
          >
            Question Type Mapping
          </Button>
          <Button 
            variant="primary" 
            size="lg"
            className="shadow-sm"
            onClick={() => navigate('/test-name')}
          >
            Manage Test Names
          </Button>
        </div>
      </div>

      <Row>
        {tiles.map((tile) => (
          <Col md={6} lg={3} key={tile.key} className="mb-4">
            <Card
              className="shadow-sm h-100 text-center cursor-pointer hover-shadow"
              style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
              onClick={() => handleTileClick(tile.key)}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <Card.Body className="d-flex flex-column justify-content-center">
                {tile.icon}
                <h5>{tile.title}</h5>
                <p className="text-muted small">{tile.description}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default UploadData;